export default __webpack_public_path__ + "static/Graphik-Regular-Web-84f14858c842b139c05ce360dc45cc96.ttf";